export class AuthenticationPasswordValidation {
  public score: number;
  public warning: string;
  public valid: false;
}